import * as React from 'react'

import { PrimitiveButton } from '@/components/primitive'

interface IProps {
  value: string
  placeHolder: string
  onChangeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void
  onClickHandler: () => void
}

const Search = (props: IProps) => {
  const { value, placeHolder, onChangeHandler, onClickHandler} = props

  const theme = null

  React.useEffect(() => {
    const theme = localStorage.getItem('theme')
  }, [theme])

  return (
    <div className='flex items-center justify-center m-4 text-blue'>
      <input
        type='text'
        value={value}
        placeholder={placeHolder}
        onChange={onChangeHandler}
        className='max-w-md sm:w-1/2 md:w-2/3 dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 rounded-lg py-3 hover:ring-2 dark:text-white m-3'
      />
      <PrimitiveButton className='sm:flex sm:1/2' onClick={onClickHandler}>
        Limpiar
      </PrimitiveButton>
    </div>
  )
}
export default Search
